import React from 'react';
import { Alert, Modal, Thumbnail, Icon, Text, Color } from '@bb/elements-web';
import styled from 'styled-components';
import { TourItemContent } from '../types';

type PreBookingInfoModalProps = {
  item?: TourItemContent & {
    preBookingInformation?: string;
    line1?: string;
    city?: string;
    province?: string;
    list_price?: string;
    dom?: string;
    thumbnail?: string;
  };
  onOk: () => void;
  onClose: () => void;
};

const PreBookingInfoModal: React.FC<PreBookingInfoModalProps> = ({
  item,
  onOk,
  onClose,
}) => {
  if (!item) return <></>;
  return (
    <Modal
      open
      title="Important Notice"
      onOk={onOk}
      onCancel={onClose}
      okText="Keep listing"
      cancelText="Remove from tour"
      hideCloseIcon
      dataCy="pre-booking-info-modal"
    >
      <StyledAlert
        type="info"
        message={<Text>{item.preBookingInformation}</Text>}
        showIcon
      />
      <StyledLayoutGrid>
        <StyledImageContainer>
          <Thumbnail
            dataCy="pre-booking-item-thumbnail"
            size="small"
            src={item.thumbnail}
          />
        </StyledImageContainer>

        <div>
          <StyledInternalLayoutGrid>
            <Text
              style={{
                color: Color.PRIMARY,
              }}
              thickness="bold"
            >
              {item.availability}
            </Text>
            <Text>•</Text>
            <Text style={{ color: Color.LIGHT_GREY }}>
              {item.listingStatus}
            </Text>
          </StyledInternalLayoutGrid>
          <StyledInternalLayoutGrid>
            <Text thickness="bold">{item.line1}</Text>
            <Text style={{ color: Color.LIGHT_GREY }}>
              {item.city}, {item.province}
            </Text>
          </StyledInternalLayoutGrid>
          <StyledInternalLayoutGrid>
            <Text>{item.list_price} </Text>
            <Icon
              icon="clockCircleOutlined"
              size={10.5}
              style={{
                margin: '8px 0px 0px 0px',
              }}
            />
            <Text style={{ color: Color.LIGHT_GREY }}>{item.dom} d</Text>
          </StyledInternalLayoutGrid>
        </div>
      </StyledLayoutGrid>
    </Modal>
  );
};

const StyledImageContainer = styled.div`
  display: flex;
`;

const StyledAlert = styled(Alert)`
  margin: 0px 0px 10px 0px;
  &&& ant5.alert {
    padding-bottom: 10px;
  }
`;

const StyledLayoutGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 6px;
  justify-content: left;
  align-items: center;
`;

const StyledInternalLayoutGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr;
  grid-gap: 4px;
  margin: 0px 0px 4px 0px;
`;

export default PreBookingInfoModal;
